/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/
import ENV from "react-dotenv";


import React from "react";


import {Helmet} from "react-helmet";


import {Col} from "react-bootstrap";


type BlockContentHeaderProps = {
    headerText: string;
    pageTitle?: boolean;
};


export const BlockContentHeaderComponent: React.FC<BlockContentHeaderProps> = ({
    headerText, pageTitle = false
}): JSX.Element => {


    return (


        <Col xs={11} as={"h1"} className={`block-header-component`}>

            <span>{headerText}</span>

            {/* Helmet Module Component - Set Document Title */}
            {pageTitle &&
	        <Helmet>
		        <title>{`${ENV.APP_TITLE} - ${headerText}`}</title>
	        </Helmet>
            }
            {/* /Helmet Module Component - Set Document Title */}

        </Col>
    );

};


export default BlockContentHeaderComponent;
